import React, { Component } from 'react';
import './App.css';

import TopicSelect from './pages/TopicSelect';
import Onboarding from './pages/Onboarding';
import Contemplate from './pages/Contemplate';
import Respond from './pages/Respond';
import CommunityAnswers from './pages/CommunityAnswers';
import Course from './pages/Course';
import Dashboard from './pages/Dashboard'

import { AppContainer, Phone } from './components/styledComponents';
import { questions } from './data/questions'

export class App extends Component {
	state = {
		page: 0,
	  	questions,
	  	questionIndex: 0
	}

	next = () => this.setState({ page: this.state.page + 1})
	goTo = (page) => this.setState({ page })
	chooseTopic = (topic) => this.setState({ topic, page: 2 }) 
	render() {
		const question = this.state.questions[this.state.questionIndex];
		const pages = [
		  {
		    component: <Onboarding onProceed={this.next} />,
		  },
		  {
		    component: <TopicSelect chooseTopic={this.chooseTopic} onProceed={this.next} />,
		  },
		  {
		    component: <Course goTo={this.goTo} topic={this.state.topic} onProceed={this.next} />,
		  },
		  {
		    component: <Contemplate onProceed={this.next} question={question}  />,
		  },
		  {
		    component: <Respond question={question} onProceed={this.next} />,
		  },
		  {
		    component: <CommunityAnswers onProceed={this.next} goTo={this.goTo} />,
		  },
		  {
		    component: <Dashboard topic={this.state.topic} chooseTopic={this.chooseTopic} />,
		  },
		  
		];

	  return (
	    <AppContainer>
	      <Phone width={414} height={736}>
	      	{ pages[this.state.page].component }
	      </Phone>
	    </AppContainer>
	  );
	}
}

export default App;
